'use client';

import type { ToastVariant } from '@/atoms/Toast/Toast.variants';
import { dispatch, genId } from './toast.store';

export interface ToastActionDescriptor {
  label: string;
  altText: string;
  onClick: () => void;
}

export interface ToastHandle {
  dismiss: () => void;
}

interface ToastOptionsBase {
  variant?: ToastVariant;
  dismissButton?: boolean;
  action?: ToastActionDescriptor;
  /**
   * Stays open until the user acts on it or dismisses it, instead of auto-dismissing.
   * Reserve it for state the user must resolve (e.g. an app update waiting to install).
   */
  persistent?: boolean;
}

export type ToastOptions = ToastOptionsBase &
  ({ title: string; description?: string } | { title?: string; description: string });

export function toast(options: ToastOptions): ToastHandle {
  const id = genId();

  dispatch({
    type: 'ADD_TOAST',
    toast: {
      id,
      variant: options.variant ?? 'default',
      title: options.title,
      description: options.description,
      dismissButton: options.dismissButton ?? false,
      action: options.action,
      persistent: options.persistent ?? false,
      open: true,
    },
  });

  return { dismiss: () => dispatch({ type: 'DISMISS_TOAST', toastId: id }) };
}
